function h(e, u) {
  for (var l = -1, n = e == null ? 0 : e.length, t = Array(n); ++l < n; )
    t[l] = u(e[l], l, e);
  return t;
}
export {
  h as default
};
